import { Journey } from '@/features/journeys'
import { MissionProgress } from '@/features/missions/types/mission'
import { Data } from '@/shared/types/data'
import { ProgressResponse } from '@/shared/types/user-progress'
import { api } from '@/shared/services/api'

import { API_PATHS } from './paths'
import type { InitialUserData } from './types'

export async function fetchInitialUserDataClient(): Promise<InitialUserData> {
  const [gamificationDataRes, progressRes, missionProgressesRes, journeysRes] =
    await Promise.allSettled([
      api.get('/user/gamification/data').then(response => response.data.record),
      api
        .get('/user/gamification/progress')
        .then(response => response.data.record),
      api
        .get('/user/missions/progresses')
        .then(response => response.data.records),
      api.get('/user/journeys').then(response => response.data.records)
    ])

  const entries: [
    keyof InitialUserData,
    InitialUserData[keyof InitialUserData]
  ][] = []

  if (
    gamificationDataRes.status === 'fulfilled' &&
    gamificationDataRes.value !== undefined
  ) {
    entries.push([API_PATHS.DATA, { record: gamificationDataRes.value as Data }])
  }

  if (progressRes.status === 'fulfilled' && progressRes.value !== undefined) {
    entries.push([
      API_PATHS.USER_PROGRESS,
      { record: progressRes.value as ProgressResponse }
    ])
  }

  if (
    missionProgressesRes.status === 'fulfilled' &&
    missionProgressesRes.value !== undefined
  ) {
    entries.push([
      API_PATHS.USER_MISSIONS_PROGRESSES,
      {
        records: missionProgressesRes.value as MissionProgress[]
      }
    ])
  }

  if (journeysRes.status === 'fulfilled' && journeysRes.value !== undefined) {
    entries.push([
      API_PATHS.JOURNEYS,
      { records: journeysRes.value as Journey[] }
    ])
  }

  return Object.fromEntries(entries) as InitialUserData
}
